import { UserType } from '../types';

export function getSafeUser(user?: any): UserType {
  return {
    id: user?.customerIdHash || user?.id || '',
    cpf: user?.documento || user?.document || user?.cpf || '',
    phone: user?.celular || user?.phone || '',
    birthdate: user?.dataNascimento || user?.birthdate || '',
    fullName: user?.nome || user?.full_name || user?.fullName || '',
    email: user?.email || '',
  } as UserType;
}
